export default __webpack_public_path__ + "static/media/EmilyLow_Resume.df23e192.pdf";